var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLargeTransaction = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.996,
    height: 15.923,
    viewBox: "0 0 17.996 15.923",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_large_transaction",
    d: "M654.26,410.855a1.558,1.558,0,0,1-1.284-.675l-.762-1.109a5.2,5.2,0,0,1-9.7-2.024h.493a.52.52,0,0,0,.52-.519.514.514,0,0,0-.092-.294l-.752-1.1-1.147-1.668a.518.518,0,0,0-.721-.135.51.51,0,0,0-.135.135l-1.9,2.769a.52.52,0,0,0,.428.813h.536a7.962,7.962,0,0,0,13.575,5.11,8.049,8.049,0,0,0,1.058-1.307C654.334,410.854,654.3,410.855,654.26,410.855Zm-6.181-4.846h-.791a.272.272,0,0,1-.272-.272h0v-.4a.272.272,0,0,1,.272-.272h.791a.272.272,0,0,1,.272.272h0a.519.519,0,0,0,1.038,0v0a1.312,1.312,0,0,0-1.187-1.3v-.278a.519.519,0,0,0-1.038,0v.282a1.312,1.312,0,0,0-1.187,1.3v.4a1.312,1.312,0,0,0,1.31,1.31h.791a.272.272,0,0,1,.272.272h0v.4a.272.272,0,0,1-.272.272h-.791a.272.272,0,0,1-.272-.272h0a.519.519,0,0,0-1.038,0v0a1.312,1.312,0,0,0,1.187,1.3v.278a.519.519,0,0,0,1.038,0v-.281a1.312,1.312,0,0,0,1.187-1.3v-.4A1.312,1.312,0,0,0,648.079,406.009Zm8.545.278a.519.519,0,0,0-.46-.278h-.536a7.965,7.965,0,0,0-14.633-3.8h.11a1.554,1.554,0,0,1,1.284.675l.762,1.109a5.2,5.2,0,0,1,9.7,2.024h-.493a.519.519,0,0,0-.428.813l.757,1.1,1.147,1.668a.52.52,0,0,0,.722.134.534.534,0,0,0,.134-.134l.687-1,1.216-1.769A.518.518,0,0,0,656.624,406.287Z",
    transform: "translate(-638.689 -398.567)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLargeTransaction);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_large_transaction.1dee033d525ca1dbcf8cfee1ba7914b6.svg";